import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const StudyMaterialAddToCartCreateSlice = createSlice({
  name: "StudyMaterialAddToCartCreateSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    studyMaterialAddToCartCreate: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successStudyMaterialAddToCartCreate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureStudyMaterialAddToCartCreate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearStudyMaterialAddToCartCreate: (state) => {
      state.data = {};
    },
  },
});

export const {
  studyMaterialAddToCartCreate,
  successStudyMaterialAddToCartCreate,
  failureStudyMaterialAddToCartCreate,
  clearStudyMaterialAddToCartCreate,
} = StudyMaterialAddToCartCreateSlice.actions;

export default StudyMaterialAddToCartCreateSlice.reducer;
